import React, { useState } from 'react'
import { Col, Form, Row, Select } from 'antd'
import { selectRule } from '../../../utils/rules'
import NormalForm from '../NormalForm'
import { ButtonEx } from '../../../shared.style'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import {
  createAnnouncement,
  fetchAnnouncementList,
  updateAnnouncement
} from '../../../stores/announcement'
import { ACTION } from '../../../utils/constants'
import { useDeepEffect } from '../../../utils/hooks'
import moment from 'moment'

const ManageAnnouncement = (props) => {
  const { actionState, setActionState, setBack, factoryState, heroId } = props
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const { materials } = useSelector((state) => state.material)
  const [materialState, setMaterialState] = useState({})

  useDeepEffect(() => {
    form.setFieldsValue({
      expirationDate: moment(new Date()),
      type: 'รับซื้อปกติ'
    })
    if (actionState === ACTION.EDIT) {
      form.setFieldsValue({
        type: factoryState.announcementType,
        materialId: factoryState.material.id,
        amountMinimum: Number(factoryState.amountMinimum),
        amountQuota: factoryState.amountQuota,
        expirationDate: moment(factoryState.expirationDate),
        image: factoryState.image,
        includeVat: factoryState.includeVat,
        payments: factoryState.payments,
        presaleDocument: factoryState.presaleDocument.split(','),
        price: Number(factoryState.price),
        productManagement: factoryState.productManagement.split(','),
        productSample: factoryState.productSample,
        remark: factoryState.remark,
        transports: factoryState.transports.split(',')
      })
      setMaterialState({
        id: factoryState.material.id,
        name: factoryState.material.name,
        image: factoryState.material.productImage,
        unit: factoryState.material.unit
      })
    }
  }, [actionState])

  async function onFinish(values) {
    if (!isEmpty(materialState)) {
      const data = {
        type: values.type,
        heroId: heroId,
        materialId: materialState.id,
        amountMinimum: values.amountMinimum,
        amountQuota: values.amountQuota,
        expirationDate: values.expirationDate
          ? moment(values.expirationDate).toISOString()
          : null,
        image:
          values.image || 'https://bscscan.com/images/logo-bscscan.svg?v=0.0.3',
        includeVat: values.includeVat,
        payments: values.payments,
        presaleDocument: values.presaleDocument.join(),
        price: values.price,
        productManagement: values.productManagement.join(),
        productSample: values.productSample,
        remark: values.remark,
        transports: values.transports.join()
      }

      if (actionState === ACTION.EDIT) {
        data.id = factoryState.id
        await dispatch(updateAnnouncement(data))
      } else {
        await dispatch(createAnnouncement(data))
      }
      await setActionState(ACTION.LIST)
      await dispatch(
        fetchAnnouncementList({
          heroId: heroId
        })
      )
    } else {
      alert('โปรดเลือกสินค้า')
    }
  }

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item label="ชนิดการประกาศ" name="type" {...selectRule}>
        <Select style={{ width: '100%' }}>
          <Select.Option value="รับซื้อปกติ">รับซื้อปกติ</Select.Option>
          {/* <Select.Option value="ตามหาสินค้า">ตามหาสินค้า</Select.Option> */}
        </Select>
      </Form.Item>
      <NormalForm
        form={form}
        materials={materials}
        materialState={materialState}
        setMaterialState={setMaterialState}
      />
      <Row justify="center" gutter={8}>
        <Col span={24}>
          <p style={{ textAlign: 'center' }}>
            หมายเหตุ : ประกาศรับซื้อจะหมดอายุอัตโนมัติ 24:00 น. ของวันที่ยืนราคา
            กรุณาเข้ามาอัพเดทอย่างสม่ำเสมอ
          </p>
        </Col>
        <Col>
          <ButtonEx
            color="#707070"
            type="primary"
            onClick={() => setBack(ACTION.LIST)}>
            กลับ
          </ButtonEx>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            {`${actionState === ACTION.CREATE ? 'สร้าง' : 'แก้ไข'}ประกาศ`}
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

export default ManageAnnouncement



// WEBPACK FOOTER //
// ./src/pages/AccountFactory/ManageAnnouncement/index.js